<template>
    <div>
        <div class="row">
            <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 offset-sm-2 offset-md-3 offset-lg-4">
                <div class="card">
                    <div class="card-header text-center" style="background: #208bc9">
                        <img src="@/assets/Icon120-narrow.png">
                        <h5 style="color: white;">Login to ReportBuilder</h5>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label>Username</label>
                            <input type="text" class="form-control" v-model="username">
                        </div>

                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control" v-model="password" @keydown.enter="login">
                        </div>

                        <button class="btn btn-primary btn-block" @click="login" :disabled="viewState == 'Busy'">
                            <span class="mdi mdi-login-variant"></span> Login
                        </button>
                        
                        <div class="d-flex d-flex justify-content-center mt-4 mb-2" v-if="viewState == 'Busy'">
                            <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
                        </div>

                        <div class="alert alert-danger mt-3" v-if="viewState == 'Error'">
                            <p class="mb-1">{{ errorMessage }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Globals, RouteNames } from '../utils/constants'
    import moment from 'moment'
    import axios from 'axios'

    export default {        
        data() {
            return {
                viewState: 'Idle',
                error: null,
                errorMessage: '',
                username: '',
                password: ''
            }
        },
        methods: {
            async login() {
                this.viewState = 'Busy'
                try {
                    let result = await axios.create().post('/api/auth/token', {
                        grant_type: 'password',
                        username: this.username,
                        password: this.password
                    })

                    let payload = result.data
                    if (payload.expires_in && !isNaN(parseInt(payload.expires_in))) {
                        this.$store.commit('setSession', payload)

                        let redirectPath = this.$route.query.redirect ? this.$route.query.redirect : '/'
                        this.$router.push(redirectPath)
                    }
                    else {
                        throw new Error('Unable to parse access token or expiry')
                    }
                } catch (err) {
                    this.viewState = 'Error'
                    if (err.response && err.response.status == 401) {
                        this.errorMessage = `Couldn't log you in, please check your username and password are correct`    
                    }
                    else {
                        this.errorMessage = `Something went wrong logging you in, please try again or contact your support team`
                    }
                    console.log(err.response)
                }                
            }
        }
    }
</script>